import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import { DashboardAssessment } from '../models';


const KEY_ACTION = ActionType.GetDashboardAssessmentsRequest;
const ACTIONS    = [
  ActionType.GetDashboardAssessmentsRequest,
  ActionType.GetDashboardAssessmentsResponse,
  ActionType.GetDashboardAssessmentsError,
];


type Payload = DashboardAssessment[];


type Meta = {
  clientId: number;
};


/**
 * Dispatch this action to retrieve assessments for selected client
 *
 * @param userClientId - the client id for the currently logged in user
 * @param clientId - the client id currently selected
 */
export const getDashboardAssessmentsAction = (
  userClientId: number,
  clientId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.GetDashboardAssessments,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      userClientId,
      clientId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { clientId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${clientId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { clientId } = action.meta;
  const metaTag       = `${clientId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['dashboardAssessments'],
    payload,
    successState,
  );
};

export const getDashboardAssessmentsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
